/**
 * ページタイトルを設定
 * @param title
 */
export const useTitle = (title: string) => {
  document.title = title;
};
